module.exports = __webpack_public_path__ + "static/media/Pie_Chart.8594ef93.gif";